(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Severity', Severity);

    Severity.$inject = ['$resource'];

    function Severity ($resource) {
        var resourceUrl =  'api/severities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': { url: 'api/severities/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();
